
import AppProjectEdit from "@/components/project/ProjectEdit.vue";
import Vue from "vue";
import {Project} from "@/models/base";
import {ProjectService} from "@/services";
import {ProjectEditState} from "@/utils/project/project-edit-state";



export default Vue.extend({
	data() {
		return {
			state: new ProjectEditState(),
			ready: false
		};
	},
	computed: {},
	methods: {
		onCancel() {
			this.$router.push("/projects");
		},
		async onSave(project:Project){
			await this.$router.push(`/projects/edit/${project.ID}`);
		}
	},
	async created() {
		let id = parseInt(this.$route.params.id);
		if (id) {
			this.state.project = await ProjectService.get(id);
		}
		this.ready = true;
	},
	components: {
		AppProjectEdit
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});
